/**
 * React hook to handle snackbars
 */

import { useContext } from 'react';

import { SnackbarContext } from '../../../components/PageLayout/SnackbarContext';

const useSnackBar = () => useContext(SnackbarContext);

export default useSnackBar;
